// extracted by mini-css-extract-plugin
module.exports = {"div":"Sect4_Comp2_div__Q_cI7","mobile":"Sect4_Comp2_mobile__lVv6d","desktop":"Sect4_Comp2_desktop__2S2mq"};